import React, { useState, useEffect } from 'react';
import { useSelector, useDispatch } from '../common/react-redux-hooks';
import { setIsAllLocalMarkets } from '../../actions/rldToolActions';
import {
  RLD_IS_ALL_LOCAL_MARKETS_LABEL,
  RLD_LOCAL_MARKETS_IDENTIFIERS,
} from './RldConstant';

const RldAllLocalMarkets = () => {
  const dispatch = useDispatch();
  const {
    sti: selectedStudyTypeId,
    sd: selectedStudyDescription,
  } = useSelector(state => state.rldTool.study.selectedStudy);
  // checkbox to be disabled for NON local markets studies
  const [isCheckboxDisabled, setIsCheckboxDisabled] = useState(true);
  const [isCheckboxChecked, setIsCheckboxChecked] = useState(false);

  useEffect(() => {
    if (
      RLD_LOCAL_MARKETS_IDENTIFIERS &&
      selectedStudyTypeId &&
      RLD_LOCAL_MARKETS_IDENTIFIERS.includes(selectedStudyTypeId)
    ) {
      setIsCheckboxDisabled(false);
    } else {
      setIsCheckboxDisabled(true);
      setIsCheckboxChecked(false);
      dispatch(setIsAllLocalMarkets(false));
    }
  }, [selectedStudyDescription]);

  const handleStatusChange = event => {
    setIsCheckboxChecked(event.target.checked);
    dispatch(setIsAllLocalMarkets(event.target.checked));
  };

  return (
    <div className="rldDictionaryOnlyWrapper">
      <input
        type="checkbox"
        name="isAllLocalMarkets"
        id="isAllLocalMarkets"
        onChange={handleStatusChange}
        disabled={isCheckboxDisabled}
        checked={isCheckboxChecked}
      />
      <label htmlFor="isAllLocalMarkets">
        <span>{RLD_IS_ALL_LOCAL_MARKETS_LABEL}</span>
      </label>
    </div>
  );
};
export default RldAllLocalMarkets;
